import { useBrandStore } from 'stores';
import TopAdsView from './TopAds.View';

import { useState } from 'react';
import { CreativeAd } from 'types/components/creatives';
import usePerformanceAdsManager from './usePerformanceAdsManager';
import TopAdsCreativePreviewModal from './Layout/TopAdsCreativePreviewModal';
import { FilterValues, TopAdsFilterType } from './types';

const TopAds = () => {
  const { brand } = useBrandStore();
  const [showPreview, setShowPreview] = useState(false);
  const [adToPreview, setAdToPreview] = useState<CreativeAd | null>(null);

  const {
    ads,
    tab,
    loading,
    filters,
    onDateRangeChange,
    onBrandCategoryChange,
    onTabChange,
    onFetchNext,
    tilesContainerRef,
  } = usePerformanceAdsManager();

  const onTileClick = (creativeAd: CreativeAd) => {
    setAdToPreview(creativeAd);
    setShowPreview(true);
  };

  const onCloseModal = () => {
    setShowPreview(false);
    setTimeout(() => {
      setAdToPreview(null);
    }, 250);
  };

  const onFilterChange = (type: TopAdsFilterType, value: any) => {
    switch (type) {
      case 'category':
        onBrandCategoryChange(value as string);
        break;
      case 'dateRange':
        onDateRangeChange(value as typeof filters.dateRange);
        break;
      case 'tab':
        onTabChange(value as typeof filters.tab);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <TopAdsView
        tilesContainerRef={tilesContainerRef}
        filters={filters as FilterValues}
        tab={tab}
        ads={ads}
        brand={brand}
        loading={loading}
        onFetchNext={onFetchNext}
        onTileClick={onTileClick}
        onFilterChange={onFilterChange}
      />
      <TopAdsCreativePreviewModal open={showPreview} ad={adToPreview} onClose={onCloseModal} />
    </>
  );
};

export default TopAds;
